import { string } from 'yup';

const rule = {
	name: 'price',
	method ({ message } = { message: 'Please enter valid price.' }) {

		return this.test('price', message, function (value) {

			const { createError } = this;
			return /^([1-9]+[0-9]*)(\.)?([0-9]{1,2})?$/gi.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
